import { ListViewColumn } from '@/types';

import { toListViewColumnCreateInput, toListViewColumnUpdateInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

const base = createSanitizedResourceService<
    ListViewColumn,
    ReturnType<typeof toListViewColumnCreateInput>,
    ReturnType<typeof toListViewColumnUpdateInput>
>('/api/list-view-columns', toListViewColumnCreateInput, toListViewColumnUpdateInput);

export const listViewColumnService = {
    ...base,
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
};
